module.exports = __webpack_public_path__ + "img/face-party.204cae0a.svg";